import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Field, StyledInput } from 'pages/ManageClubEurostar/ManageClubEurostar.styles';
import Label from 'components/ui/Label';
import { isValidPassengersNumber } from 'utils/validators';
import { PAX_DESCRIPTIONS } from 'constants/booking';

import { AddCompanionsWrapper, StyledDescription } from './AddPassengersCta.styles';

const EvacuationChairBookings = ({ register, errors, getValues }) => {
  const { adultsEvac, childrenEvac } = getValues();
  return (
    <AddCompanionsWrapper>
      <Field>
        <Label htmlFor="adultsEvac">
          <FormattedMessage id="addPassengers.adultsEvac" />{' '}
          <StyledDescription>
            (<FormattedMessage id={`groupBooking.${PAX_DESCRIPTIONS.youths}`} />)
          </StyledDescription>
        </Label>
        <StyledInput
          {...register('adultsEvac', {
            validate: (value) => !value || (isValidPassengersNumber(value) && Number(value) + Number(childrenEvac) <= 1)
          })}
          type="number"
          inputMode="numeric"
          id="adultsEvac"
          data-testid="adultsEvac"
          validationState={errors.adultsEvac ? 'error' : ''}
        />
      </Field>
      <Field>
        <Label htmlFor="childrenEvac">
          <>
            <FormattedMessage id="addPassengers.children" /> (<FormattedMessage id="wheelchairSearch.answers.evac" />)
            <StyledDescription>
              (<FormattedMessage id={`groupBooking.${PAX_DESCRIPTIONS.children}`} />)
            </StyledDescription>
          </>
        </Label>
        <StyledInput
          {...register('childrenEvac', {
            validate: (value) => !value || (isValidPassengersNumber(value) && Number(value) + Number(adultsEvac) <= 1)
          })}
          type="number"
          inputMode="numeric"
          id="childrenEvac"
          data-testid="childrenEvac"
          validationState={errors.childrenEvac ? 'error' : ''}
        />
      </Field>
    </AddCompanionsWrapper>
  );
};

EvacuationChairBookings.propTypes = {
  register: PropTypes.func,
  errors: PropTypes.shape({
    adultsEvac: PropTypes.string,
    childrenEvac: PropTypes.string
  }),
  getValues: PropTypes.func
};

export default EvacuationChairBookings;
